/**
 * W60 (§3.11 #10) · One date formatter for both workspaces.
 *
 * §16.2: "dates, currencies, units, and timezones must be explicit". W47 gave
 * the Control workspace `formatWhen` (a timestamp with its zone) and left the
 * Investment workspace on three helpers and two libraries that print a bare
 * local time — so the same breach read as a different moment on the two
 * sides of the product. This module is now the only place a timestamp is
 * rendered; `complianceShared` re-exports it and the Investment helpers
 * delegate to it.
 *
 *   formatWhen(value) → "19 Sept 2026, 21:40 BST"   (a moment: explicit zone)
 *   formatDay(value)  → "19 Sept 2026"              (a date-valued field: no
 *                        time, so no zone — an effective date is a calendar
 *                        day, not an instant)
 */
export const formatWhen = (value) => {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  // Explicit components rather than dateStyle/timeStyle: ECMA-402 forbids
  // combining those shorthands with an individual option such as
  // timeZoneName, and doing so throws rather than degrading.
  return date.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit', timeZoneName: 'short'
  })
}

export const formatDay = (value) => {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
}
